// ============================================================================
// REPOSITORY: AlertInboxRepository — CRUD e listener da caixa de alertas
// ARQUIVO: src/services/AlertInboxRepository.js
// ============================================================================

import { collection, doc, limit, onSnapshot, orderBy, query, updateDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FS } from '../shared/constants/firestorePaths';

export function subscribeAlertInbox(callback) {
  const q = query(
    collection(db, ...FS.alertInbox()),
    orderBy('created_at', 'desc'),
    limit(200),
  );
  return onSnapshot(
    q,
    (snap) => callback(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    () => callback([]),
  );
}

export async function markAlertAsRead(id) {
  await updateDoc(doc(db, ...FS.alertInbox(), id), { is_read: true });
}

export async function archiveAlert(id) {
  await updateDoc(doc(db, ...FS.alertInbox(), id), { status: 'archived', is_read: true });
}
